export * from './Modal/Modal';
export { useModal } from './Modal/useHandleModal';
